// CollapsibleLegend.tsx
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, HelpCircle } from 'lucide-react';

interface CollapsibleLegendProps {
  title: string;
  children: React.ReactNode;
  initiallyExpanded?: boolean;
  icon?: React.ReactNode;
}

const CollapsibleLegend: React.FC<CollapsibleLegendProps> = ({
  title,
  children,
  initiallyExpanded = false,
  icon
}) => {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

  return (
    <div className="bg-white rounded-lg shadow-sm border mb-4">
      <div 
        className="p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center">
          {isExpanded ? (
            <ChevronDown className="h-5 w-5 text-gray-500 mr-2" />
          ) : (
            <ChevronRight className="h-5 w-5 text-gray-500 mr-2" />
          )}
          <h3 className="text-lg font-medium text-gray-900 flex items-center">
            {icon && <span className="mr-2">{icon}</span>}
            {title}
          </h3>
        </div>
        <div className="text-sm text-blue-600">
          {isExpanded ? 'Hide' : 'Show'} details
        </div>
      </div>
      
      {isExpanded && (
        <div className="p-4 border-t border-gray-100">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleLegend;
